import { useMemo } from "react"

import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useRetargetingFactory = ({ fetch, siteSelected: { id: siteId }, collections: { collectionsURL, setItems } }) => useMemo(() => ({
  reorder: async partners => {
    setItems(partners)
    return await fetch({
      method: 'put',
      url: `site/${siteId}/${collectionsURL}/reorder`,
      data: { partners },
      params: { site: siteId },
    });
  },
}), [collectionsURL, fetch, siteId, setItems])

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('retargeting-partner')
  .extendHookCollectionsFactory('retargeting-partners')
  .extend(useRetargetingFactory)
  .factory()

export {
  Provider as RetargetingProvider,
  useStore as useRetargetingStore,
}
